import styled from "styled-components";

export const BeaconStyle = styled.div`
  .signal-div {
    position: relative;
  }

  .signal-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 13px;
    text-align: center;
  }
  .signal-img {
    height: 45px;
    display: block;
  }
  .table-item2 {
    font-family: light-pro, sans-serif;
  }

  .heading-icon {
    color: #f28809;
  }

  .grey {
    color: grey;
  }

  .red {
    color: red;
  }

  .yellow {
    color: #f9f907;
  }

  .green {
    color: green;
  }

  .table-loading {
    text-align: center;
  }

  .table-div {
    padding: 20px;
    width: 80%;
    display: flex;
    height: 270px;
    overflow-y: auto;
    margin-bottom: 20px;
    flex-wrap: wrap;
    justify-content: center;
    align-self: center;
    font-family: medium-pro, sans-serif;
  }

  .table-head {
    position: sticky;
    top: -20px;
    background: white;
  }

  .table-item {
    font-size: 1rem;
  }

  /* For large devices */
  @media screen and (max-width: 1024px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 1440px) {
    .table-item {
      font-size: 0.7rem;
    }
  }
  @media screen and (max-width: 500px) {
    .table-item {
      font-size: 0.5rem;
    }
  }
`;
